{
  "welcome": {
    "title": "Bienvenue, {{name}}",
    "title_noName": "Bienvenue dans Rhemn",
    "body": "Tout ce qui s'illumine vous montre à quoi il sert. Explorez dans l'ordre de votre choix, quand vous le souhaitez.",
    "start": "Commencer l'exploration",
    "later": "Plus tard"
  },
  "card": {
    "tryIt": "Essayer",
    "takeALook": "Découvrir",
    "pro": "Inclus dans Rhemn Pro",
    "close_aria": "Fermer"
  },
  "pill": {
    "progress": "{{count}} sur {{total}} explorés",
    "progress_short": "{{count}} sur {{total}}",
    "done": "Terminé",
    "done_aria": "Terminer l'exploration",
    "complete": "Tout est exploré"
  },
  "sr": {
    "started": "Mode exploration activé. Les boutons montrent ce qu'ils font avant d'agir.",
    "hint": "Mode exploration. Montre d'abord ce que fait cet élément.",
    "ended": "Mode exploration désactivé."
  },
  "settings": {
    "row": "Comment fonctionne Rhemn",
    "row_sub": "Un bref aperçu de chaque partie",
    "row_aria": "Comment fonctionne Rhemn : explorer à nouveau l'app",
    "helpCaption": "Aide"
  },
  "steps": {
    "intention": {
      "title": "Intention du jour",
      "body": "Écrivez la chose qui compte le plus aujourd'hui, et cochez-la une fois accomplie."
    },
    "now": {
      "title": "Votre journée, au fil des prières",
      "body": "Rhemn découpe votre journée à chaque prière. Vous voyez le temps restant avant la prochaine et ce que vous avez prévu d'ici là."
    },
    "verse": {
      "title": "Éclairages sur le verset",
      "body": "Posez une question sur le verset du jour, lisez un court tafsir et trouvez des versets sur le même thème."
    },
    "qibla": {
      "title": "Direction de la Qibla",
      "body_chrome": "La direction de la Kaaba depuis l'endroit où vous êtes, en degrés par rapport au nord.",
      "body_ios": "Indique la Kaaba depuis l'endroit où vous êtes. Activez la boussole en direct pour qu'elle vous suive quand vous tournez."
    },
    "prayer": {
      "title": "Heures de prière",
      "body_chrome": "Les cinq prières du jour là où vous êtes. Choisissez la méthode de calcul suivie par votre mosquée.",
      "body_ios": "Votre prochaine prière en un coup d'œil. Ouvrez-la pour voir les cinq horaires et un rappel pour chacun."
    },
    "tasks": {
      "title": "Tâches",
      "body": "Rangez vos tâches dans des listes, et donnez à chacune sa place entre les prières."
    },
    "notes": {
      "title": "Vos notes",
      "body_chrome": "Écrivez, ou parlez simplement. Rhemn transcrit vos notes vocales et vos réunions, puis les résume.",
      "body_ios": "Écrivez, ou parlez simplement. Rhemn transforme vos paroles en notes claires et résumées."
    },
    "profile": {
      "title_chrome": "Votre profil",
      "body_chrome": "Les paramètres de votre compte et de confidentialité. Revenez ici pour explorer Rhemn à nouveau.",
      "title_ios": "Plus",
      "body_ios": "Versets enregistrés, Qibla et paramètres de votre compte. Vous pouvez explorer Rhemn à nouveau d'ici."
    }
  }
}
